export default "__VITE_ASSET__CdpwmCV$__"